import _ from 'lodash'
import store from '@/store'
import httpService from './http-service'
import { showMandatoryCommentModal } from '@/core/modal-service'
import { sharedText } from '../core/utils'

function mergeRows(r1, r2) {
  const chain = _.chain([...r1, ...r2]).reduce((acc, v) => {
    if (!acc[v.itemId]) {
      acc[v.itemId] = v
    } else {
      acc[v.itemId].quantity += v.quantity
      if(v.mandatoryComment) {
        acc[v.itemId].mandatoryComment = v.mandatoryComment
      }
    }
    return acc
  }, {}).values()

  return chain.value()
}

function getCart() {
  return store.getters['commerce/cart']
}

function getUnselectedRows() {
  const cart = getCart()
  const selectedRowIds = store.getters['commerce/cartSelectedRows'][cart.id] || []
  if(selectedRowIds.length > 0 && cart) {
    return _.filter(cart.rows, row => !_.includes(selectedRowIds, row.id))
  }
  return []
}

// order note
function saveNote(lineItemId, note) {
  return httpService.post('cart/addNotes', { note: { lineItemId, note } })
}

function deleteNote(lineItemId) {
  return httpService.post('cart/deleteNote', { lineItemId })
}

// assembly note
function saveAssemblyNote(lineItemId, note) {
  return httpService.post('cart/addAssemblyNote', { note: { lineItemId, note } })
}

function deleteAssemblyNote(lineItemId) {
  return httpService.post('cart/deleteAssemblyNote', { lineItemId })
}

// Mark machine
function setMachine(setMachinePayload) {
  return httpService.post('cart/setMachine', setMachinePayload)
}

async function markMachineForRow($event, currentRowOrRows) {
  const { machineOwnerId, machineId } = $event || {}
  const setMachinePayload = _.isArray(currentRowOrRows) ? _.map(currentRowOrRows, row => ({ lineItemId: row, machineId, machineOwnerId })) : [{ lineItemId: currentRowOrRows, machineId, machineOwnerId }]
  const response = await setMachine(setMachinePayload)
  return response
}

// Preview row
async function previewRow(row) {
  const { data } = await httpService.get('cart/previewRow', row)
  if(data.previewRow) {
    return data.previewRow
  } else if(data.mandatoryComment) {
    const comments = await showMandatoryCommentModal({ mandatoryComment: data.mandatoryComment, title: sharedText('addMandatoryComment') })
    setMandatoryCommentOnCartItems([row], comments)
    row.mandatoryComment = JSON.stringify(row.mandatoryComment)
    const { data: previewData } = await httpService.get('cart/previewRow', row)
    if(previewData.previewRow) {
      return previewData.previewRow
    }
  }
}

// mandatory comments
async function updateMandatoryComment(lineItemId, mandatoryComment) {
  return httpService.post('cart/updateMandatoryComment', { lineItemId, mandatoryComment })
}

async function setMandatoryCommentOnCartItems(cartItems, mandatoryComment) {
  _.forEach(mandatoryComment, (val, key) => {
    const itemToEnrich = _.find(cartItems, item => item.itemId === key)
    if(itemToEnrich) {
      itemToEnrich.mandatoryComment = val
    }
  })
}

export default {
  mergeRows,
  getUnselectedRows,
  getCart,
  saveNote,
  deleteNote,
  saveAssemblyNote,
  deleteAssemblyNote,
  setMachine,
  markMachineForRow,
  previewRow,
  updateMandatoryComment,
  setMandatoryCommentOnCartItems
}
